export default __webpack_public_path__ + "static/media/hb_male_fertility.9d0a0f5b.jpg";